export default {
    /** 未选中时色值 */
    uncheckColor: "#ccc",
    /** 已选中时色值 */
    checkedColor: "#dc3b40",
    /** 复选框文字颜色 */
    color: "#333",
    /** 未选中图标 */
    uncheckIcon: "icon-loni-check-circular",
    /** 已选中图标 */
    checkedIcon: "icon-loni-checked-circular",
    /** 图标和文字大小 */
    size: "16px"
}
